// extracted by mini-css-extract-plugin
export default {"residentForm":"residentForm_residentForm__dK6Pd","withCopy":"residentForm_withCopy__E0KZX"};